export default "__VITE_ASSET__1f7289ea__"